import { Button } from '@synoptic/ui-kit/button/button.tsx';
import {
  ModalContent,
  ModalHeader,
  ModalRoot,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.tsx';
import { FC } from 'react';
import {
  interactionModalAction,
  interactionModalContent,
  interactionModalDescription,
  interactionModalTitle,
} from './interaction-required-modal.css.ts';

export const InteractionRequiredModal: FC<{
  open: boolean;
  onOpenChange: (open: boolean) => void;
}> = ({ open, onOpenChange }) => {
  return (
    <ModalRoot open={open} onOpenChange={onOpenChange}>
      <ModalContent className={interactionModalContent}>
        <ModalHeader withoutCloseIcon>
          <ModalTitle className={interactionModalTitle}>
            Interaction required
          </ModalTitle>
        </ModalHeader>
        <p className={interactionModalDescription}>
          Browsers require user interaction before they will play audio. <br />
          Just click okay to continue.
        </p>
        <Button
          className={interactionModalAction}
          size={'medium'}
          onClick={() => onOpenChange(false)}
        >
          Okay
        </Button>
      </ModalContent>
    </ModalRoot>
  );
};
